module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"vs_previous_month":"前月比","vs_previous_year":"昨年同月比"},"en":{"vs_previous_month":"vs previous month","vs_previous_year":"vs previous year"}}')
  delete Component.options._Ctor
}
